import { SUBSCRIPTION_PACKAGES } from "./../Settings/components/MembershipPackages/subscriptionPackages";
import { useEffect } from "react";
import { useUserId } from "../query/hooks/helpers";
import { useSubscriptionV3Query } from "../query/subscriptions/queries";
import {
  useClientQuery,
  useMemberProfile,
  useUserProfile
} from "../query/users/queries";
import { identifyWithCommonFields, page } from "./analytics";
import { useWSStore } from "../store";

export const useIdentify = () => {
  const userId = useUserId();
  const userQuery = useUserProfile(userId, {
    retry: false
  });
  const memberQuery = useMemberProfile(userId, {
    retry: false
  });
  const clientQuery = useClientQuery(userId);
  const subscriptionQuery = useSubscriptionV3Query(userId);

  useEffect(() => {
    if (
      userQuery.isFetched &&
      memberQuery.isFetched &&
      clientQuery.isFetched &&
      subscriptionQuery.isFetched
    ) {
      if (!window.userEmail) {
        window.userEmail = userQuery.data?.email as string;
        window.intercomUserHash = userQuery.data?.intercomUserHash as string;
        page();
      }
      identifyWithCommonFields(userId, {
        email: userQuery.data?.email,
        intercomUserHash: userQuery.data?.intercomUserHash,
        plan: SUBSCRIPTION_PACKAGES.find(
          sub => sub.package === subscriptionQuery.data?.package
        )?.title,
        subscribedDate: subscriptionQuery.data?.createdAt,
        subscriptionStarts: subscriptionQuery.data?.trialEnd,
        isClient: !!clientQuery.data?.clientId,
        isMember: !!memberQuery.data?.memberId,
        ...userQuery.data?.profile,
        ...memberQuery.data?.profile
      });
    }
  }, [
    clientQuery.data?.clientId,
    clientQuery.isFetched,
    memberQuery.data?.memberId,
    memberQuery.data?.profile,
    memberQuery.isFetched,
    subscriptionQuery.data?.createdAt,
    subscriptionQuery.data?.trialEnd,
    subscriptionQuery.isFetched,
    userId,
    userQuery.data?.email,
    userQuery.data?.intercomUserHash,
    userQuery.data?.profile,
    userQuery.isFetched
  ]);
};
